import React from 'react';

import { ResponseDisplayProps } from '@/features/method-tester/types';
import { Text } from '@asphalt-react/typography';

const BASE_RESPONSE_CLASSNAMES = `border p-3 rounded min-h-[40px] text-sm whitespace-pre-wrap`;
const SUCCESS_STYLE = 'bg-green-50 border-green-200 text-green-800';
const ERROR_STYLE = 'bg-red-50 border-red-200 text-red-800';

const ResponseDisplay: React.FC<ResponseDisplayProps> = ({ response }) => {
  if (!response) return null;

  const responseClassNames = `${BASE_RESPONSE_CLASSNAMES} ${
    response.success ? SUCCESS_STYLE : ERROR_STYLE
  }`;

  return (
    <>
      <Text size="s">Response:</Text>
      <div
        data-testid="individual-response-display"
        className={responseClassNames}
      >
        {JSON.stringify(response, null, 2)}
      </div>
    </>
  );
};

export default ResponseDisplay;
